import { Col, Row } from "antd";
import React, { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { InputField, InternationalPhoneInput, ReactSelectField } from "../../../../../atoms/FormElement";
import { getEmailValidationRules, getMinMaxValidationRules, getValidationProps } from "../../../../../libs/form";
import { translateService } from "../../../ducks/services";
import { marital_status } from "../../utils";

let translationTimeoutId: NodeJS.Timeout;

export const ResidentialTenantDetailsFields = () => {
  const { configData } = useSelector((state: any) => state.newBooking);
  const { control, setValue, formState } = useFormContext();

  const { errors } = formState;

  const defaultProps = { control, setValue };

  // Watch firstName and lastName to auto-generate arabicName via translation
  const firstName = useWatch({ control, name: "firstName" });
  const lastName = useWatch({ control, name: "lastName" });

  useEffect(() => {
    const fullName = [firstName, lastName].filter(Boolean).join(" ");

    if (fullName && fullName.length > 1) {
      clearTimeout(translationTimeoutId);

      translationTimeoutId = setTimeout(async () => {
        const response = await translateService(fullName);
        if (response?.translatedText) {
          setValue("arabicName", response.translatedText);
        }
      }, 2000);
    }

    return () => {
      clearTimeout(translationTimeoutId);
    };
  }, [firstName, lastName, setValue]);

  return (
    <>
      <Row gutter={24}>
        <Col span={8}>
          <InputField
            fieldname="email"
            label="Email address"
            {...defaultProps}
            {...getValidationProps({
              fieldName: "email",
              errors,
              isRequired: true,
              rules: getEmailValidationRules(),
            })}
          />
        </Col>
        <Col span={8}>
          <InputField
            fieldname="firstName"
            label="First name"
            {...defaultProps}
            {...getValidationProps({ fieldName: "firstName", errors, isRequired: true })}
          />
        </Col>
        <Col span={8}>
          <InputField
            fieldname="lastName"
            label="Last name"
            {...defaultProps}
            {...getValidationProps({ fieldName: "lastName", errors, isRequired: true })}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={8}>
          <InputField
            fieldname="arabicName"
            label="Tenant name arabic"
            {...defaultProps}
            {...getValidationProps({ fieldName: "arabicName", errors, isRequired: true })}
          />
        </Col>
        <Col span={8}>
          <InternationalPhoneInput
            fieldname="mobile"
            countryCodeFieldname="countryCode"
            label="Mobile number"
            control={control}
            setValue={setValue}
            errors={errors}
            isRequired={true}
            defaultCountryCode="971"
          />
        </Col>
        <Col span={8}>
          <InputField
            fieldname="workPhone"
            label="Work phone"
            {...defaultProps}
            {...getValidationProps({
              fieldName: "workPhone",
              errors,
              isRequired: false,
              rules: getMinMaxValidationRules({ label: "Work phone", min: 8, max: 12 }),
            })}
            iProps={{ placeholder: "12345678" }}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={8}>
          <ReactSelectField
            fieldname="nationality"
            label="Nationality"
            selectOption={configData.nationalityList}
            {...defaultProps}
            {...getValidationProps({ fieldName: "nationality", errors, isRequired: true })}
          />
        </Col>
        <Col span={8}>
          <ReactSelectField
            fieldname="maritalStatus"
            label="Marital status"
            selectOption={marital_status}
            {...defaultProps}
            {...getValidationProps({ fieldName: "maritalStatus", errors, isRequired: true })}
          />
        </Col>
      </Row>
    </>
  );
};
